import React, { useState } from 'react';

const MASK_PLACEHOLDER = '••••••••••••••••';

const MaskedField = ({
  label,
  value,
  onChange,
  name,
  errors,
  required = false,
  disabled = false,
  multiline = false,
  rows = 2,
  /** When true, render only the input-group (InlineFormRow supplies label). */
  compact = false,
}) => {
  const [visible, setVisible] = useState(false);

  const displayValue = visible ? value : (value ? MASK_PLACEHOLDER : '');

  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  const toggleVisibility = () => setVisible((prev) => !prev);

  const inputMarkup = (() => {
    const hasValue = Boolean(value);

    if (multiline) {
      return (
        <div className="input-group">
          <textarea
            name={name}
            className={`form-control form-control-sm ${errors?.[name] ? 'is-invalid' : ''}`}
            value={displayValue}
            onChange={handleChange}
            disabled={disabled}
            rows={rows}
            readOnly={!onChange}
            autoComplete="off"
          />
          {hasValue && (
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={toggleVisibility}
              tabIndex={-1}
            >
              <i className={`fa ${visible ? 'fa-eye-slash' : 'fa-eye'}`} />
            </button>
          )}
        </div>
      );
    }

    return (
      <div className="input-group">
        <input
          type={visible ? 'text' : 'password'}
          name={name}
          className={`form-control form-control-sm ${errors?.[name] ? 'is-invalid' : ''}`}
          value={hasValue && !onChange ? MASK_PLACEHOLDER : value}
          onChange={handleChange}
          disabled={disabled}
          autoComplete="off"
        />
        {hasValue && (
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={toggleVisibility}
            tabIndex={-1}
          >
            <i className={`fa ${visible ? 'fa-eye-slash' : 'fa-eye'}`} />
          </button>
        )}
        {errors?.[name] && !compact && (
          <div className="invalid-feedback d-block">
            {Array.isArray(errors[name]) ? errors[name][0] : errors[name]}
          </div>
        )}
      </div>
    );
  })();

  // Compact mode: InlineFormRow renders label + wraps this component.
  if (compact) {
    return inputMarkup;
  }

  return (
    <div className="mb-3">
      {label && (
        <label className="form-label">
          {label}
          {required && <span className="text-danger ms-1">*</span>}
        </label>
      )}
      {inputMarkup}
      {!multiline && errors?.[name] && (
        <div className="invalid-feedback d-block">
          {Array.isArray(errors[name]) ? errors[name][0] : errors[name]}
        </div>
      )}
    </div>
  );
};

export default MaskedField;
